import { useMemo } from 'react';

import { filterVisiblePlannerRows } from '../../helpers/planner-base/filter-visible-planner-rows';
import usePlannerStore from '../../store';
import { AssignmentType, RowItem } from '../../types';
import { useRowHeights } from './use-row-heights';

interface UsePlannerDerivedRowsParams {
  rows: RowItem[];
  assignmentsMap: Map<string, AssignmentType[]>;
}

interface PlannerDerivedRows {
  visibleRows: RowItem[];
  rowHeights: Map<string, number>;
}

export const usePlannerDerivedRows = ({
  rows,
  assignmentsMap,
}: UsePlannerDerivedRowsParams): PlannerDerivedRows => {
  const collapsedGroups = usePlannerStore(store => store.collapsedGroups);

  const visibleRows = useMemo(() => {
    return filterVisiblePlannerRows(rows, collapsedGroups);
  }, [rows, collapsedGroups]);

  const rowHeights = useRowHeights(visibleRows, assignmentsMap);

  return {
    visibleRows,
    rowHeights,
  };
};
